
export const logoGeneration = {
    toolName: 'Logo Generator',
    toolDescription: 'Use AI technology to generate professional Logo designs. Just enter a description to create a unique brand identity',
    promptTemplate: 'Please design a modern minimalist style Logo for me, containing the following elements:',
    
    // Prompt input related
    promptLabel: 'Logo Description',
    promptDescription: 'Describe the Logo you want to create',
    promptPlaceholder: 'Please enter your Logo description...',
    
    // Prompt suggestions
    promptSuggestions: {
      title: 'Prompt Suggestions',
      business: 'Business Logo: Modern minimalist technology company Logo, blue tone, containing letter "T"',
      creative: 'Creative Logo: Art studio Logo, colorful brush effect, creative font',
      minimal: 'Minimal Logo: Minimalist coffee shop Logo, brown tone, coffee bean element',
      tech: 'Tech Logo: AI technology company Logo, futuristic design, blue-green gradient'
    },
    
    // Generation parameters
    parameters: {
      style: 'Style',
      colors: 'Colors',
      elements: 'Elements',
      modern: 'Modern',
      classic: 'Classic',
      minimal: 'Minimal',
      creative: 'Creative'
    },
    
    // Results related
    results: {
      title: 'Logo Generation Result',
      downloading: 'Downloading Logo...',
      downloadSuccess: 'Logo downloaded successfully!',
      downloadFailed: 'Logo download failed, please try again',
      regenerating: 'Regenerating...',
      saveToCollection: 'Save to Collection'
    },
    
    // Error messages
    errors: {
      emptyPrompt: 'Please enter Logo description',
      generationFailed: 'Logo generation failed, please try again',
      networkError: 'Network error, please check connection',
      serverError: 'Server error, please try again later'
    }
  };
